module.exports = [
  require('./compare'),
  require('./deepEqual'),
  require('./equal'),
  require('./larger'),
  require('./largerEq'),
  require('./smaller'),
  require('./smallerEq'),
  require('./unequal')
];



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/function/relational/index.js
// module id = 1199
// module chunks = 0